export default "__VITE_ASSET__CFohrYwE__"